import { PALETTE, SIZES, MQ_TABLET } from '../../../../constants';
import { MediaQueryStyleSheet } from 'react-native-responsive';
import ResponsiveDimensionValues from '../../../../components/common/responsive-dimension-values';

const WINDOW_WIDTH = ResponsiveDimensionValues.windowWidth;
const bgColor = 'rgba(0,0,0,.2)';

export default MediaQueryStyleSheet.create({
  root: {
    flex: 1,
    paddingVertical: 0,
  },
  content: {
    paddingHorizontal: 0,
  },
  headline: {
    textAlign: 'center',
    marginBottom: 20,
  },
  footer: {
    textAlign: 'center',
  },
  rowItem: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: 10,
  },
  switchLabel: {
    flex: 1,
  },
  switchToggle: {
    alignItems: 'flex-end',
  },
  empty: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonContainer: {
    padding: 20,
    paddingBottom: 0,
    flexDirection: 'row',
  },
  saveButton: {
    alignSelf: 'center',
    flex: 1,
  },
  label: {
    color: PALETTE.secondaryText,
  },
  seperatorPadding: {
    backgroundColor: bgColor,
    marginBottom : 8,
    paddingHorizontal: 20
  },
  currencyColor: {
    color: '#fff'
  },
  mainContainer:{
    width: '93.5%', 
    padding: '20px'
  },
  tabsForMultisig:{ 
    display: 'flex',
    flexDirection:'row',
    width: '100%',
    justifyContent: 'center'
  }
});

export const centerSpinner = {
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
    justifyItems: 'center'
};
export const scrollBarStyle = {
  height: '500px',
  overflow: 'auto',
};
